export const VIDEO_CHAT_SERVICE_BASE_URL = 'https://video-chat-service.mysoluto.com';
